import { Typography, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import RadioButton from "../../../../common/RadioButton";
import { LinkButton, SecondaryButton } from "../../../../common/Buttons";
import {
  getHealthcareProxy,
  getHealthcareQuestionByCategory,
  postHealthcareProxy,
} from "../../../../services/documentServices";
import { QuestionByCategoryType } from "../../../../constants/constants";
import { toast } from "react-hot-toast";
import { getUserIdFromLocalStorage } from "../../../../utils/Utilities";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Circles } from "react-loader-spinner";
import { Form, Formik } from "formik";

const SubAuthorities = ({ next, setButtonDisabled }) => {
  const { t } = useTranslation();
  const { id } = useParams();

  const [subAuthorization, setSubAuthorization] = useState([]);
  const [data, setData] = useState([]);
  const [showNotes, setShowNotes] = useState(false);
  const [notes, setNotes] = useState({
    note: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  async function fetchData() {
    setIsLoading(true);
    try {
      const result = await getHealthcareProxy(id);
      if (result?.success && result?.payLoad) {
        setData(result.payLoad);
        if (result.payLoad?.furtherRegulations?.length) {
          setNotes(result.payLoad?.furtherRegulations[0]);
          setShowNotes(true);
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  }


  async function fetchSubAuthorization() {
    setButtonDisabled(true);
    const result = await getHealthcareQuestionByCategory(
      QuestionByCategoryType.SUB_AUTHORITIES,
      id
    );
    if (result?.success) {
      setSubAuthorization(
        {
          title: result?.payLoad?.[0],
          data: result?.payLoad[0]?.questions?.map((item) => ({
            id: item.questionId,
            yes: item?.healthProxyAnswer?.answer
              ? item?.healthProxyAnswer?.answer === "yes"
                ? true
                : false
              : null,
            ...item,
            ...item.healthProxyAnswer,
          }))
        }
      );
    }
    setButtonDisabled(false);
  }


  useEffect(() => {
    fetchData();
    fetchSubAuthorization();

  }, []);
  const setYes = (e, type) => {
    if (type === "sub-authorization") {
      const updateList = {
        ...subAuthorization,
        data: subAuthorization?.data?.map((ele) => {
          return ele.id == e.id
            ? {
              ...ele,
              yes: true,
            }
            : ele;
        })
      };
      setSubAuthorization(updateList);
    }
  };
  const setNo = (e, type) => {
    if (type === "sub-authorization") {
      const updateList = {
        ...subAuthorization,
        data: subAuthorization?.data?.map((ele) => {
          return ele.id == e.id
            ? {
              ...ele,
              yes: false,
            }
            : ele;
        })
      };
      setSubAuthorization(updateList);
    }
  };

  const setAllTrue = (currentObj) => currentObj.yes == true;

  const handleSubmit = async () => {
    setButtonDisabled(true);
    const payload = {
      ...data,
      ...(showNotes && {
        furtherRegulations: [notes],
      }),
      healthProxyAnswers: [
        ...data.healthProxyAnswers,
        ...subAuthorization?.data?.map((item) => ({
          ...item,
          answer: item.yes ? "yes" : item.yes == null ? null : "no",
        })),


      ],
      checkListTab4:
        subAuthorization?.data?.every(setAllTrue)
          ? 2
          : 1,
    };
    const result = await postHealthcareProxy(payload, id);
    if (result?.success) {
      // toast.success(
      //   t(
      //     result?.message
      //       .toLowerCase()
      //       .replaceAll(" ", "-")
      //       .replaceAll("/", "-")
      //       .replaceAll(",", "")
      //       .replaceAll("'", "")
      //   )
      // );
      next();
    }
    setButtonDisabled(false);
  };

  const handleClickNotes = () => {
    setShowNotes(true);
  };
  return (
    <Formik
      initialValues={{ place: '' }}
      enableReinitialize
      onSubmit={(values) => {
        handleSubmit(values);
      }}
    >
      {(formik) => {
        return (
          <Form id="form_submit" onSubmit={formik.handleSubmit}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
            className="summary-table documents-card-height">

            {isLoading ? (
              <Box component="div" className="loader-container">
                <Circles color="#dfc8db" height={80} width={80} />{" "}
              </Box>
            ) : (
              <Box component="div" width="60%" className="medical-care-container">
                {" "}
                <Typography variant="p" fontWeight="bold" className="mt-5">
                  {" "}
                  {t(subAuthorization?.title?.translationKey)}{" "}
                </Typography>{" "}
                <Box
                  padding="0 2rem"
                  component="div"
                  className="section-1"
                  style={{
                    width: "100%",
                  }}
                >
                  <Box component="div" className="sub-section-1">
                    <Typography variant="p" marginRight="1rem">
                      {" "}
                      {t("YES")}{" "}
                    </Typography>{" "}
                    <Typography variant="p"> {t("NO")} </Typography>{" "}
                  </Box>{" "}
                  <ol>
                    {" "}
                    {subAuthorization?.data?.map((elem, index) => {
                      return (
                        <li>
                          <Box component="div" key={index} className="sub-section-2">
                            <Typography variant="p" margin="0 0.5rem" width="80%">
                              {" "}
                              {elem?.translationKey
                                ? t(elem.translationKey)
                                : ""}{" "}
                            </Typography>{" "}
                            <RadioButton
                              value="0"
                              theme="box"
                              paddingLeft="1rem"
                              checked={elem.yes}
                              onChange={() => {
                                setYes(elem, "sub-authorization");
                              }}
                            />{" "}
                            <RadioButton
                              value="1"
                              theme="box"
                              checked={!elem.yes && elem.yes != null}
                              onChange={() => {
                                setNo(elem, "sub-authorization");
                              }}
                            />{" "}
                          </Box>{" "}
                        </li>
                      );
                    })}{" "}
                  </ol>{" "}
                </Box>{" "}

              </Box>
            )}{" "}
          </Form>
        );
      }}
    </Formik>
  );
};
export default SubAuthorities;
